module.exports = __webpack_public_path__ + "img/icon_qr.6da0a909.png";